import type { NgwMapInstance } from "../types";

export function removeLayerIfExists(ngwMap: NgwMapInstance, id: string): void {
  if (ngwMap.getLayer(id)) {
    ngwMap.removeLayer(id);
  }
}
